const APIs = {
  ADMIN_SETTINGS_SCOPES: 'admin/settings/:key',
  ADMIN_SETTINGS: 'admin/settings',
}

export default APIs
